import { usePreferences } from "./usePreferences";
import { getDeviceTimezone } from "@src/packages/utils/date";

/**
 * Returns the user's preferred timezone from the backend,
 * falling back to the device timezone if not yet loaded.
 */
export function useTimezone(): string {
  const { data: preferences } = usePreferences();
  return preferences?.timezone || getDeviceTimezone();
}
